import { ProfilingCodeType } from 'clickNgo/entities/profilingCode'
import { I2070Form } from 'clickNgo/models/crud/forms'

import type { FlagRecordDependency, FlagRecordDependencyType } from '../../model/types'

const normalizeText = (value?: string | number | Date | null): string => {
  return value === undefined || value === null ? '' : String(value).trim()
}

export const normalizeFlagRecordDependencyType = (
  value?: string | number | Date | null
): FlagRecordDependencyType | null => {
  const normalizedType = normalizeText(value).toLocaleLowerCase().replace(/\s+/g, '')

  if (normalizedType === ProfilingCodeType.UserRights.toLocaleLowerCase()) {
    return 'UserRights'
  }

  if (
    normalizedType === 'epi' ||
    normalizedType === ProfilingCodeType.Program.toLocaleLowerCase() ||
    normalizedType === 'programs' ||
    normalizedType === ProfilingCodeType.Accreditation.toLocaleLowerCase() ||
    normalizedType === 'accreditations'
  ) {
    return 'EPI'
  }

  return null
}

export const mapFlagRecordDependencyFrom2070Form = (
  data: I2070Form
): FlagRecordDependency | null => {
  const flagCode = normalizeText(data.FlagCode)
  const toolsFlagCode = normalizeText(data.ToolsFlagCode)
  const type = normalizeFlagRecordDependencyType(data.Type)

  if (!flagCode || !toolsFlagCode || !type) {
    return null
  }

  return {
    entryId: normalizeText(data.EntryId),
    flagCode,
    market: normalizeText(data.Market),
    toolsFlagCode,
    type,
  }
}
